
export enum LanguageType {
  Ja = 'ja',
  En = 'en',
  Zh = 'zh',
  Ko = 'ko'
}

export enum ThemeType {
  Light = 'light',
  Dark = 'dark'
}
